/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Entity identity for an experiment assignment; provide exactly one customer or lead grain. */
export type AssignmentGrainInput =
  {   /** Customer identity for the assignment. */
  customer: CustomerAssignmentGrainInput; lead?: never; }
  |  { customer?: never;   /** Seller lead identity for the assignment. */
  lead: LeadAssignmentGrainInput; };

/** Customer identity used to evaluate or record an experiment assignment. */
export type CustomerAssignmentGrainInput = {
  /** Anonymous visitor identifier used when no customer account is available. */
  anonymousId?: Types.Scalars['UUID']['input'] | null | undefined;
  /** Customer identifier whose assignments should be evaluated. */
  customerId?: Types.Scalars['UUID']['input'] | null | undefined;
};

/** Details for evaluating one experiment variant. */
export type EvaluateExperimentVariantInput = {
  /** Whether evaluating the variant should also record an impression. */
  autoImpression?: Types.Scalars['Boolean']['input'] | null | undefined;
  /** Entity identity for the assignment. */
  grain: AssignmentGrainInput;
  /** Experiment key to evaluate. */
  key: Types.Scalars['NonEmptyString']['input'];
  /** Optional properties used as additional evaluation context. */
  props?: Types.Scalars['JSONObject']['input'] | null | undefined;
};

/** Entity and experiment keys for retrieving variant assignments. */
export type ExperimentVariantsInput = {
  /** Entity identity whose assignments should be retrieved. */
  grain: AssignmentGrainInput;
  /** Experiment or feature-flag keys to retrieve; results preserve first-seen key order and remove duplicates. */
  keys: Array<Types.Scalars['NonEmptyString']['input']>;
};

/** Seller lead identity used to evaluate or record an experiment assignment. */
export type LeadAssignmentGrainInput = {
  /** Optional customer identity associated with the seller lead. */
  customer?: CustomerAssignmentGrainInput | null | undefined;
  /** Seller lead identifier for the assignment. */
  sellerLeadId: Types.Scalars['UUID']['input'];
};

export type EvaluateListingExperimentVariantMutationVariables = Exact<{
  input: Types.EvaluateExperimentVariantInput;
}>;


export type EvaluateListingExperimentVariantMutation = { evaluateExperimentVariant:
    | { __typename: 'EvaluateExperimentVariantPayload', assignment: { key: Types.Scalars['NonEmptyString']['output'], value: Types.Scalars['String']['output'] | null, variationId: Types.Scalars['Int']['output'] | null } }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export type EvaluateListingExperimentQueryVariables = Exact<{
  input: Types.ExperimentVariantsInput;
  addressId?: Types.Scalars['UUID']['input'] | null | undefined;
}>;


export type EvaluateListingExperimentQuery = { experiments: { evaluations:
      | { __typename: 'ExperimentsQueryEvaluationsSuccess', data: Array<{ key: Types.Scalars['NonEmptyString']['output'], value: Types.Scalars['String']['output'] | null, variationId: Types.Scalars['Int']['output'] | null }> }
      | { __typename: 'InvalidInputError', code: Types.Scalars['String']['output'], message: Types.Scalars['String']['output'] }
      | { __typename: 'NotFoundError', code: Types.Scalars['String']['output'], message: Types.Scalars['String']['output'] }
      | { __typename: 'UnauthorizedError', code: Types.Scalars['String']['output'], message: Types.Scalars['String']['output'] }
     | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const EvaluateListingExperimentVariantDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation EvaluateListingExperimentVariant($input: EvaluateExperimentVariantInput!) {
  evaluateExperimentVariant(input: $input) {
    __typename
    ... on EvaluateExperimentVariantPayload {
      assignment {
        key
        value
        variationId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EvaluateListingExperimentVariantMutation, EvaluateListingExperimentVariantMutationVariables>;
export const EvaluateListingExperimentDocument = /*#__PURE__*/ new TypedDocumentString(`
    query EvaluateListingExperiment($input: ExperimentVariantsInput!, $addressId: UUID) {
  experiments {
    evaluations(input: $input, addressId: $addressId) {
      __typename
      ... on ExperimentsQueryEvaluationsSuccess {
        data {
          key
          value
          variationId
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EvaluateListingExperimentQuery, EvaluateListingExperimentQueryVariables>;